import React, { useState } from "react";
import SwiperCore, { Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.min.css";
// import "swiper/components/pagination/pagination.min.css";
import "./TimePicker.scss";

SwiperCore.use([Pagination]);

const TimePicker = () => {
    const [hour, setHour] = useState(0);
    const [minute, setMinute] = useState(0);

    const handleHourChange = (swiper) => {
        const { activeIndex } = swiper;
        setHour(activeIndex);
    };

    const handleMinuteChange = (swiper) => {
        const { activeIndex } = swiper;
        setMinute(activeIndex);
    };

    return (
        <div className="time-picker-vertical">
            <Swiper
                direction="vertical"
                slidesPerView={3}
                centeredSlides={true}
                onSlideChange={handleMinuteChange}
                pagination={{ clickable: false }}
                onInit={(swiper) => {
                    swiper.slideTo(minute);
                }}
            >
                {[...Array(60)].map((_, index) => (
                    <SwiperSlide key={index} className="time-picker-vertical-item">
                        {index.toString().padStart(2, "0")}
                    </SwiperSlide>
                ))}
            </Swiper>

            <Swiper
                direction="vertical"
                slidesPerView={3}
                centeredSlides={true}
                onSlideChange={handleHourChange}
                pagination={{ clickable: false }}
                onInit={(swiper) => {
                    swiper.slideTo(hour);
                }}
            >
                {[...Array(24)].map((_, index) => (
                    <SwiperSlide key={index} className="time-picker-vertical-item">
                        {index.toString().padStart(2, "0")}
                    </SwiperSlide>
                ))}
            </Swiper>

        </div>
    );
};

export default TimePicker;